/* The Collector Edit — empty-cart experience (drawer + cart page).
   Only renders when the cart is empty (keys off the theme's .cart-items__empty-button, which
   exists ONLY in the empty state). Adds: a headline, a "Shop New Arrivals" CTA, and a
   "For You Picks" horizontal carousel with arrows. Picks are personalized from the visitor's
   recently-viewed history (same Meili recency-weighted brand/model logic as the homepage
   For-You engine), falling back to newest arrivals for first-time visitors. Built for conversion. */
(function () {
  'use strict';
  var SEARCH = 'https://search.collectoredit.com', INDEX = 'products';
  var TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  var LS = window.localStorage;
  var STOP = { the:1,and:1,with:1,'for':1,'in':1,of:1,a:1,an:1,to:1,bag:1,handbag:1,purse:1,authentic:1,'pre':1,owned:1,used:1,vintage:1,leather:1,small:1,medium:1,large:1,mini:1 };

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  function money(n) { return '$' + (Number(n) || 0).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function get(k, d) { try { return JSON.parse(LS.getItem(k)) || d; } catch (e) { return d; } }
  function words(t) { return (t || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 1; }); }
  function topKey(o) { var b = null, n = -1; for (var k in o) { if (o[k] > n) { n = o[k]; b = k; } } return b; }

  function recoQuery(list) {
    if (!list.length) return '';
    var bw = {}; list.forEach(function (x, i) { if (x.b) bw[x.b] = (bw[x.b] || 0) + 1 / (1 + i * 0.25); });
    var brand = topKey(bw) || ''; var bwset = {}; words(brand).forEach(function (w) { bwset[w] = 1; });
    var wc = {}; list.slice(0, 8).forEach(function (x) { words(x.t).forEach(function (w) { if (!STOP[w] && !bwset[w] && w.length > 2) wc[w] = (wc[w] || 0) + 1; }); });
    var kw = Object.keys(wc).filter(function (w) { return wc[w] >= 2; }).sort(function (a, b) { return wc[b] - wc[a]; }).slice(0, 2);
    return (brand + ' ' + kw.join(' ')).trim();
  }

  function meili(body) {
    return fetch(SEARCH + '/indexes/' + INDEX + '/search', {
      method: 'POST', headers: { 'Authorization': 'Bearer ' + TOKEN, 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) { return (d && d.hits) || []; }).catch(function () { return []; });
  }

  var ATTRS = ['title', 'price', 'image_ce', 'image2_ce', 'handle_ce', 'brand'];
  var picksPromise = null;
  function loadPicks() {
    if (picksPromise) return picksPromise;
    var rv = get('ce_recently_viewed', []);
    var q = recoQuery(rv);
    picksPromise = (q
      ? meili({ q: q, limit: 16, attributesToRetrieve: ATTRS })
      : Promise.resolve([])
    ).then(function (hits) {
      // top up / fall back to newest arrivals so the rail is always full
      if (hits.length >= 8) return hits.slice(0, 16);
      return meili({ q: '', sort: ['ce_added_ts:desc'], limit: 16, attributesToRetrieve: ATTRS }).then(function (nw) {
        var seen = {}, out = [];
        hits.concat(nw).forEach(function (h) { var k = h.handle_ce; if (k && !seen[k]) { seen[k] = 1; out.push(h); } });
        return out.slice(0, 16);
      });
    });
    return picksPromise;
  }


  // Title never repeats the brand (brand line above already shows it)
  function ceStripBrand(title, brand) {
    title = String(title || ''); brand = String(brand || '');
    if (brand && title.toLowerCase().indexOf(brand.toLowerCase()) === 0) {
      var rest = title.slice(brand.length).replace(/^[\s\-–—:,]+/, '');
      if (rest) return rest;
    }
    return title;
  }
  function cardHTML(x) {
    var handle = x.handle_ce || '', img = x.image_ce || '', brand = x.brand || '', title = x.title || '';
    var price = (x.price != null) ? x.price : 0;
    return '<a class="ce-ec__card" href="/products/' + encodeURIComponent(handle) + '">' +
      '<span class="ce-ec__imgw"><img loading="lazy" src="' + esc(img) + '" alt="' + esc(title) + '"></span>' +
      '<span class="ce-ec__b">' + esc(brand) + '</span>' +
      '<span class="ce-ec__t">' + esc(ceStripBrand(title, brand)) + '</span>' +
      '<span class="ce-ec__p">' + money(price) + '</span></a>';
  }

  var CSS = '' +
    '.ce-ec{margin-top:6px;text-align:center;width:100%;max-width:min(100%,560px);min-width:0;align-self:center;box-sizing:border-box;overflow:hidden}' +
    '.ce-ec__icon{display:flex;justify-content:center;margin:4px 0 12px;color:#16130f}' +
    '.ce-ec__title{font-family:var(--font-heading--family,"Newsreader",Georgia,serif);font-size:1.25rem;font-weight:500;margin:0 0 4px;color:#16130f}' +
    '.ce-ec__sub{font-size:.85rem;color:#6b655e;margin:0 0 18px}' +
    '.ce-ec__cta{display:inline-flex;align-items:center;justify-content:center;width:100%;max-width:320px;margin:0 auto 10px;padding:14px 22px;background:#16130f;color:#fff;text-decoration:none;font-size:.74rem;letter-spacing:.14em;text-transform:uppercase;border-radius:4px;transition:opacity .2s}' +
    '.ce-ec__cta:hover{opacity:.85}' +
    '.ce-ec__cta--ghost{background:transparent;color:#16130f;border:1px solid rgba(0,0,0,.22)}' +
    '.ce-ec__picks{margin-top:26px;text-align:left;width:100%;min-width:0}' +
    '.ce-ec__picks-head{display:flex;align-items:center;justify-content:space-between;margin:0 0 12px;padding:0 2px}' +
    '.ce-ec__picks-title{font-family:var(--font-heading--family,"Newsreader",Georgia,serif);font-size:1.02rem;font-weight:500;margin:0;letter-spacing:.01em}' +
    '.ce-ec__nav{display:flex;gap:6px}' +
    '.ce-ec__arrow{width:30px;height:30px;border-radius:50%;border:1px solid rgba(0,0,0,.16);background:#fff;color:#16130f;cursor:pointer;font-size:15px;line-height:1;display:flex;align-items:center;justify-content:center;transition:opacity .2s,background .2s}' +
    '.ce-ec__arrow:hover{background:#16130f;color:#fff}' +
    '.ce-ec__arrow.is-hidden{opacity:.3;pointer-events:none}' +
    '.ce-ec__track{display:flex;gap:12px;overflow-x:auto;scroll-behavior:smooth;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding-bottom:2px;width:100%;min-width:0;max-width:100%}' +
    '.ce-ec__track::-webkit-scrollbar{display:none}' +
    '.ce-ec__card{flex:0 0 148px;width:148px;max-width:148px;text-decoration:none;color:inherit;display:block}' +
    '.ce-ec__imgw img{max-width:100%;max-height:100%}' +
    '.ce-ec__imgw{display:block;width:100%;aspect-ratio:1;border-radius:6px;overflow:hidden;background:#f5f3ef;margin-bottom:8px}' +
    '.ce-ec__imgw img{width:100%;height:100%;object-fit:cover;display:block;padding:6px;box-sizing:border-box;transition:transform .4s}' +
    '.ce-ec__card:hover .ce-ec__imgw img{transform:scale(1.04)}' +
    '.ce-ec__b{display:block;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;font-size:10.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#16130f}' +
    '.ce-ec__t{display:block;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;font-size:11.5px;color:#555;line-height:1.35;margin:2px 0 3px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
    '.ce-ec__p{display:block;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;font-size:11.5px;font-weight:600;color:#16130f}';

  function injectCSS() {
    if (document.getElementById('ce-ec-css')) return;
    var s = document.createElement('style'); s.id = 'ce-ec-css'; s.textContent = CSS; document.head.appendChild(s);
  }

  function wireArrows(root) {
    var track = root.querySelector('.ce-ec__track'), prev = root.querySelector('[data-ec-prev]'), next = root.querySelector('[data-ec-next]');
    if (!track) return;
    function upd() { var max = track.scrollWidth - track.clientWidth - 2; prev.classList.toggle('is-hidden', track.scrollLeft <= 2); next.classList.toggle('is-hidden', max <= 2 || track.scrollLeft >= max); }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd);
    setTimeout(upd, 60); setTimeout(upd, 400);
  }

  function enhance(host) {
    if (!host || host.querySelector('.ce-ec')) return;
    injectCSS();
    // hide the theme's default empty button — we render our own CTA set
    var def = host.querySelector('.cart-items__empty-button'); if (def) def.style.display = 'none';
    var el = document.createElement('div');
    el.className = 'ce-ec';
    el.innerHTML =
      '<div class="ce-ec__icon">' +
        '<svg width="34" height="34" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M6.2 12.5h19.6l1.7 12.3a2.6 2.6 0 0 1-2.58 2.95H7.08A2.6 2.6 0 0 1 4.5 24.8l1.7-12.3Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
          '<path d="M11.4 12.2V10a4.6 4.6 0 0 1 9.2 0v2.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '<path d="M4.9 17h22.2" stroke="currentColor" stroke-width="1.2"/>' +
          '<rect x="14.4" y="15.4" width="3.2" height="3.2" rx="0.7" stroke="currentColor" stroke-width="1.2"/>' +
        '</svg>' +
      '</div>' +
      '<a class="ce-ec__cta" href="/collections/new">Shop New Arrivals</a>' +
      '<a class="ce-ec__cta ce-ec__cta--ghost" href="/pages/designers">Browse Designers</a>' +
      '<div class="ce-ec__picks" hidden>' +
        '<div class="ce-ec__picks-head">' +
          '<h3 class="ce-ec__picks-title">For You Picks</h3>' +
          '<div class="ce-ec__nav"><button type="button" class="ce-ec__arrow" data-ec-prev aria-label="Previous">‹</button><button type="button" class="ce-ec__arrow" data-ec-next aria-label="Next">›</button></div>' +
        '</div>' +
        '<div class="ce-ec__track"></div>' +
      '</div>';
    host.appendChild(el);
    loadPicks().then(function (picks) {
      if (!picks || picks.length < 2) return;
      var wrap = el.querySelector('.ce-ec__picks'), track = el.querySelector('.ce-ec__track');
      track.innerHTML = picks.map(cardHTML).join('');
      wrap.hidden = false;
      wireArrows(el);
    });
  }

  function host() {
    var btn = document.querySelector('.cart-items__empty-button');
    if (!btn) return null;
    return btn.closest('.cart-items, [class*="cart-items__wrapper"], cart-items-component') || btn.parentElement;
  }

  var deb;
  function tick() { clearTimeout(deb); deb = setTimeout(function () { var h = host(); if (h) enhance(h); }, 120); }
  try { new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();
